import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmSubmitProposal from '../common/ConfirmSubmitProposal';
function SubmitProposal(_ref) {
  var fullName = _ref.fullName,
    updateUserSettingsUrl = _ref.updateUserSettingsUrl,
    editUrl = _ref.editUrl,
    formUrl = _ref.formUrl,
    submitToOpenMarketplace = _ref.submitToOpenMarketplace,
    csrfToken = _ref.csrfToken,
    animation = _ref.animation,
    disabled = _ref.disabled,
    referralProps = _ref.referralProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitted = _useState2[0],
    setIsSubmitted = _useState2[1];
  var onSubmit = function onSubmit(value) {
    return setIsSubmitted(value);
  };
  if (isSubmitted) {
    if (submitToOpenMarketplace) {
      return /*#__PURE__*/React.createElement("div", {
        className: "headline"
      }, /*#__PURE__*/React.createElement("h2", null, "Proposal sent to hiring manager!"), /*#__PURE__*/React.createElement("p", null, "The hiring manager is reviewing your proposal. If accepted, Clora will coordinate the interview."));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "headline"
    }, /*#__PURE__*/React.createElement("h2", null, "Proposal submitted!"), /*#__PURE__*/React.createElement("p", null, "Clora will review and send your proposal to the employer for consideration."));
  }
  return /*#__PURE__*/React.createElement(Fragment, null, submitToOpenMarketplace && /*#__PURE__*/React.createElement("div", {
    className: "headline"
  }, /*#__PURE__*/React.createElement("h2", null, "Submit your proposal."), /*#__PURE__*/React.createElement("p", null, "Your proposal will be sent directly to the hiring manager.", ' ', /*#__PURE__*/React.createElement("br", null), "If accepted, Clora will coordinate the interview. Check your proposal's status under My Applications.")), !submitToOpenMarketplace && /*#__PURE__*/React.createElement("div", {
    className: "headline"
  }, /*#__PURE__*/React.createElement("h2", null, "Submit your proposal."), /*#__PURE__*/React.createElement("p", null, "Clora will review and send your proposal to the employer for consideration.")), /*#__PURE__*/React.createElement("div", {
    className: "cta g-row g-flex-align-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: editUrl,
    className: "mr-30"
  }, "Edit Proposal"), /*#__PURE__*/React.createElement(ConfirmSubmitProposal, {
    fullName: fullName,
    updateUserSettingsUrl: updateUserSettingsUrl,
    formUrl: formUrl,
    submitToOpenMarketplace: submitToOpenMarketplace,
    csrfToken: csrfToken,
    animation: animation,
    disabled: disabled,
    referralProps: referralProps,
    onSubmitCallback: onSubmit
  })));
}
SubmitProposal.propTypes = {
  editUrl: PropTypes.string.isRequired,
  fullName: PropTypes.string,
  updateUserSettingsUrl: PropTypes.string.isRequired,
  formUrl: PropTypes.string.isRequired,
  submitToOpenMarketplace: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  animation: PropTypes.bool,
  disabled: PropTypes.bool,
  referralProps: PropTypes.shape({})
};
SubmitProposal.defaultProps = {
  fullName: null,
  submitToOpenMarketplace: false,
  animation: false,
  disabled: false,
  referralProps: {}
};
export default SubmitProposal;